module.exports = __webpack_public_path__ + "static/card_3-381c279ed8f70138f651956d9fb2f5a0.png";